import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useToast } from "@/components/ui/use-toast";
import { FileCheck, CheckCircle, XCircle } from "lucide-react";

const ReviewVerifications = () => {
  const { toast } = useToast();
  const [verifications] = useState([
    {
      id: 1,
      user: "John Doe",
      type: "ID Verification",
      status: "Pending",
      submittedAt: "2024-02-20",
    },
    {
      id: 2,
      user: "Jane Smith",
      type: "Document Verification",
      status: "Pending",
      submittedAt: "2024-02-19",
    },
  ]);

  const handleVerification = (id: number, action: 'approve' | 'reject') => {
    toast({
      title: `Verification ${action === 'approve' ? 'Approved' : 'Rejected'}`,
      description: `Verification #${id} has been ${action === 'approve' ? 'approved' : 'rejected'}.`,
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Review Verifications</h1>
        <FileCheck className="h-8 w-8 text-primary" />
      </div>

      <Card className="p-6">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>User</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Submitted</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {verifications.map((verification) => (
              <TableRow key={verification.id}>
                <TableCell>{verification.user}</TableCell>
                <TableCell>{verification.type}</TableCell>
                <TableCell>{verification.status}</TableCell>
                <TableCell>{verification.submittedAt}</TableCell>
                <TableCell>
                  <div className="flex space-x-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => handleVerification(verification.id, 'approve')}
                    >
                      <CheckCircle className="h-4 w-4 text-green-500" />
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => handleVerification(verification.id, 'reject')}
                    >
                      <XCircle className="h-4 w-4 text-red-500" />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
};

export default ReviewVerifications;